import React from 'react'
import {
  ButtonPrimary,
  SpacerVertical,
  TitleSecondary,
  AlertBanner,
  IconNotification
} from 'mage-deps/@klarna/bubble-ui'
import StoreSelector from './StoreSelector'
import { hooks as i18nHooks } from 'mage-i18n'
import { useFormikContext } from 'formik'
import Field, { TextAreaField } from './../FormikBubbleField'
import TopicSelector from './TopicSelector'
import FilesInput from './FilesInput'

export default function Fields() {
  const t = i18nHooks.useTranslator()
  const { isSubmitting } = useFormikContext()

  return (
    <>
      <StoreSelector />
      <SpacerVertical medium />
      <TitleSecondary>{t('hqm.support-page.create-ticket.fields.topic.question')}</TitleSecondary>
      <SpacerVertical small />
      <TopicSelector />
      <SpacerVertical small />
      <Field
        data-testid="subject"
        name="subject"
        label={t('hqm.support-page.create-ticket.fields.subject.label')}
      />
      <SpacerVertical small />
      <TextAreaField
        data-testid="description"
        name="description"
        placeholder={t('hqm.support-page.create-ticket.fields.description.label')}
      />
      <SpacerVertical small />
      <TitleSecondary>{t('hqm.support-page.create-ticket.fields.attachment.label')}</TitleSecondary>
      <SpacerVertical small />
      <AlertBanner
        iconType={IconNotification}
        content={[
          `
            ${t('hqm.support-page.create-ticket.fields.attachment.info')}
            ${t('hqm.support-page.create-ticket.fields.attachment.supportedFileTypes')}
          `
        ]}
      />
      <SpacerVertical small />
      <FilesInput
        inputId="file-input"
        inputLabel={t('hqm.support-page.create-ticket.fields.attachment.button')}
        errorContent={[t('hqm.support-page.create-ticket.fields.attachment.error')]}
      />
      <SpacerVertical small />
      <ButtonPrimary type="submit" loading={isSubmitting} data-testid="submit">
        {t('hqm.support-page.create-ticket.submit')}
      </ButtonPrimary>
      <SpacerVertical medium />
    </>
  )
}
